import { configureLocalization } from "@lit/localize";
import { sourceLocale, targetLocales } from "./generated/locales";
import { NotImplementedError } from "./utils";

export const {getLocale, setLocale} = configureLocalization({
    sourceLocale,
    targetLocales,
    loadLocale: () => import(`./generated/locales/en`),
});

/**
 * Get quantity (cardinal) string, per https://unicode-org.github.io/cldr-staging/charts/latest/supplemental/language_plural_rules.html.
 */
 export function quantityString(str: QuantityString, number: number): string | null {
    switch (getLocale()) {
        case 'pl': {
            const mod10 = number % 10;
            const mod100 = number % 100;
            if (number == 1)
                return str.one ?? str.other ?? null;
            if (2 <= mod10 && mod10 <= 4 && !(12 <= mod100 && mod100 <= 14))
                return str.few ?? str.other ?? null;
            return str.many ?? str.other ?? null;
        }
        case 'en': {
            if (number == 1)
                return str.one ?? str.other ?? null;
            return str.other ?? null;
        }
        default: throw new NotImplementedError(`Language ${getLocale()} not supported`);
    }
}

void setLocale(document.documentElement.lang);
